<template>
    <div>
        <hp5-overlay :visible="loading ? true : false" :key="loading"/>
        <div aria-live="assertive">
            <hp5-loading-panel v-if="loading" message="Please wait" state="spinning"></hp5-loading-panel>
        </div>
    </div>
</template>
    
<script setup>
    const { loading } = useFCPModel()
</script>